module.exports = {"name":"theoplayer2","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.3","built":"2018-06-21","repo":"https://bitbucket.org/npaw/theoplayer2-adapter-js","libVersion":"^6.2.6","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getPlayrate","getDuration","getBitrate","getThroughput","getRendition","getIsLive","getResource"]},"ads":[{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getTitle","getResource","getPosition"],"filename":"generic.js"}]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 16
// module chunks = 0